module.exports = __webpack_public_path__ + "img/6bdac4c.jpg";